import QuoteSalesOrder from "interfaces/QuoteSalesOrder";
import * as React from "react";
import Modal from "react-responsive-modal";

interface Props {
    data: QuoteSalesOrder;
    open: boolean;
    onClose: Function;
}

export default class ModalX extends React.Component<Props, any> {
    constructor(props: Props) {
        super(props);
    }

    public render() {
        let item = this.props.data.productGroups;

        return (
            <div style={{ textAlign: "center" }}>
                <Modal
                    open={this.props.open}
                    onClose={this.props.onClose}
                    little
                    closeOnOverlayClick={true}
                >
                    <div className="vertical-alignment-helper">
                        <div
                            className="modal-lg vertical-align-center"
                            role="document"

                        >
                            <div className="card card--form">
                                <div className="card-block">
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div>{this.props.data.jobName}</div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                marginTop: "30px",
                                            }}
                                        >
                                            {this.props.data.orderLines.map((item: any) => (
                                                <>
                                                    {" "}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <div className="d-flex pr-10">
                                                            <b>Item: </b>
                                                            {item.productName}
                                                        </div>

                                                        <div>
                                                            <b>Quantity :</b> {item.quantity}
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            border: "1px solid gray",
                                                            // margin: "10px 0",
                                                        }}
                                                    ></div>
                                                </>
                                            ))}
                                        </div>
                                        <div>
                                            {this.props.data.shippingMethod == "1"
                                                ? "ShippingMethod: Direct"
                                                : (this.props.data.shippingMethodYard == "1" ? "ShippingMethod: Yard Pickup" : "ShippingMethod: Yard Delivery")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/Modal.tsx